import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import { MAP_LABEL_LANGUAGE } from "@/views/home/maptiler/mapTilerLanguageUtils";
import { normalizeLangFromQuery } from "@/views/home/maptiler/useRouteLangQueryEffect";
import { isChinaSite } from "@/views/home/maptiler/useMapTilerSite";

/** vue-i18n locale 或 ?lang= 解析为地图标注语言 zh / en */
export const resolveMapLabelLanguage = (localeOrLang) => {
  const value = String(
    typeof localeOrLang === "object" && localeOrLang?.value != null
      ? localeOrLang.value
      : localeOrLang ?? ""
  )
    .trim()
    .toLowerCase();
  if (value === "en" || value === "en-us") return MAP_LABEL_LANGUAGE.EN;
  return MAP_LABEL_LANGUAGE.ZH;
};

/**
 * 首页 MapTiler 底图标注语言：国内站固定中文（天地图不支持可靠英文注记）；
 * 境外站按 ?lang= / locale。
 */
export function useMapLabelLanguage() {
  const { locale } = useI18n();
  const route = useRoute();
  const mapLabelLanguage = computed(() => {
    if (isChinaSite()) return MAP_LABEL_LANGUAGE.ZH;
    const fromQuery = normalizeLangFromQuery(route.query.lang);
    return resolveMapLabelLanguage(fromQuery || locale.value);
  });
  return { mapLabelLanguage };
}
